import React from 'react'

const MyInformationContext = React.createContext()

export default MyInformationContext
